import {
  Element,
  InstallSpec,
  ItemComponent,
} from "@p0security/shared/install/types";

export const AwsRdsComponents = InstallSpec({
  "iam-write": ItemComponent({
    label: "IAM management",
    description:
      "Allows P0 to manage access to Aurora and RDS instances in a VPC.",
    type: "string",
    maturity: "ga",
    schema: {
      accountId: Element({
        label: "AWS account ID",
        description: "The AWS account in which this VPC is provisioned.",
        type: "dynamic",
        step: "new",
      }),
      region: Element({
        label: "Region",
        description: "The AWS region in which this VPC is provisioned.",
        type: "string",
        step: "new",
      }),
      subnetIds: Element({
        label: "Subnet IDs",
        description: "Space-delimited list of AWS subnet IDs within this VPC.",
        type: "hidden",
      }),
    },
  }),
});
